/**
 * Shared date utility functions.
 */

/** Any value that can be coerced to a Date. */
export type DateLike = Date | string | number;

/** Coerce any value to a Date (or null). */
export function toDate(v: DateLike | null | undefined): Date | null {
  if (!v) return null;
  if (v instanceof Date) return v;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** True when v is a valid Date instance. */
export function isDate(v: unknown): v is Date {
  return v instanceof Date && !Number.isNaN(v.getTime());
}

/** Format a Date as "YYYY-MM-DD" (ISO-style, no time). Returns null for bad input. */
export function fmtISO(d: unknown): string | null {
  if (!isDate(d)) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Alias kept for brevity — same as fmtISO. */
export const fmt = fmtISO;

/** Format a Date as "DD/MM/YYYY" (UK style). Returns null for bad input. */
export function fmtUK(d: unknown): string | null {
  if (!isDate(d)) return null;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}
